<!-- Start Page Title Area -->
<div class="page-title-area">
    <div class="container" >
        <div class="page-title-content">
            <h2 data-aos="fade-down"
            data-aos-easing="linear"
            data-aos-duration="1200">Utilities</h2>
            <ul data-aos="fade-down"
            data-aos-easing="linear"
            data-aos-duration="1200">
                <li><a routerLink="/">Home</a></li>
                <li>Utilities</li>
            </ul>
        </div>
    </div>
     
</div>
<!-- End Page Title Area -->

<!-- Start Educational Area -->
<!-- <div class="aboutus-hb__control_panel">
    <div class="aboutus-hb__yearline">
        <div class="aboutus-hb__yearline_track">
            <div
            class="page-heading"
            style="
                height: 150px;
                text-align: center;
                color: #000000;
                margin-bottom: 40px;
                text-transform: uppercase;
            "
        >
            <h1>
                <b
                    >Vocbot  Tackles Challenges: Simplifying Utility Management Solutions</b
                >
            </h1>
             
        </div>
        </div>
    </div>
     
</div> -->

<section class="team-area  ">
    <div class="ai-solution-area pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">
                <!-- <div class="col-lg-12 col-md-12 col-sm-12">
                   
                </div> -->
                <div class="media col-lg-5 col-md-6 col-sm-12">
                    <div class="ai-solution-wrap-image">
                        <img  src="assets/img/utilities-bill.png" alt="image" />
                    </div>
                </div>

                <div class="text col-lg-5 col-md-6 col-sm-12 ml-3">
                    <div class="ai-solution-content">
                        <h3
                            style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            "
                        >
                        Bill Inquiries and Payments
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p
                            style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            "
                        >
                        Vocbot assists users in checking utility bills and payment status and facilitates secure online bill payments through integrated systems.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-solution-area-2 pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">
                <div class="text col-lg-5 col-md-6 col-sm-12 ml-3">
                    <div class="ai-solution-content">
                        <h3
                            style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            "
                        >
                        Usage Monitoring
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p
                            style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            "
                        >
                        Vocbot provides insights to users about their utility consumption patterns, such as water, energy, or other utility usage.
                        </p>
                    </div>
                </div>
                <div class="media col-lg-5 col-md-6 col-sm-12">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/utilities-monitoring.png" alt="image" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-solution-area pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">
                 
                   
                
                <div class="media col-lg-5 col-md-6 col-sm-12">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/utilities-alert.png" alt="image" />
                    </div>
                </div>

                <div class="text col-lg-5 col-md-6 col-sm-12 ml-3">
                    <div class="ai-solution-content">
                        <h3
                            style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            "
                        >
                        Service Outage Alerts
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p
                            style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            "
                        >
                        Vocbot notifies consumers about scheduled maintenance or unexpected service outages and offers real-time updates on the resolution progress.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-solution-area-2 pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">
                <div class="text col-lg-5 col-md-6 col-sm-12 ml-3">
                    <div class="ai-solution-content">
                        <h3
                            style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            "
                        >
                        Technical Support
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p
                            style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            "
                        >
                        Vocbot assists users in resolving technical issues, troubleshooting tips, and disruptions.
                        </p>
                    </div>
                </div>
                <div class="media col-lg-5 col-md-6 col-sm-12">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/utilities-technical.png" alt="image" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-solution-area pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">
               
                   
              
                <div class="media col-lg-5 col-md-6 col-sm-12">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/utilities-connection.png" alt="image" />
                    </div>
                </div>

                <div class="text col-lg-5 col-md-6 col-sm-12 ml-3">
                    <div class="ai-solution-content">
                        <h3
                            style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            "
                        >
                        Connection / Disconnection Requests
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p
                            style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            "
                        >
                        Users can submit requests for new utility connections or
                        disconnections. Vocbot  streamline the application process
                        and provide status updates.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-solution-area-2 pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">
                <div class="text col-lg-5 col-md-6 col-sm-12 ml-3">
                    <div class="ai-solution-content">
                        <h3
                            style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            "
                        >
                        Energy Efficiency Tips
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p
                            style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            "
                        >
                        Vocbot offers tips on optimizing energy to achieve efficiency and suggests practices to reduce utility costs and environmental impact.
                        </p>
                    </div>
                </div>
                <div class="media col-lg-5 col-md-6 col-sm-12">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/utilities-energy.png" alt="image" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-solution-area pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">
               
                <div class="media col-lg-5 col-md-6 col-sm-12">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/utilities-feedback.png" alt="image" />
                    </div>
                </div>

                <div class="text col-lg-5 col-md-6 col-sm-12 ml-3">
                    <div class="ai-solution-content">
                        <h3
                            style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            "
                        >
                        Feedback and Improvement Suggestions
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p
                            style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            "
                        >
                        Vocbot collects user feedback on utility services and provides suggestions for improvement, enhancing customer satisfaction.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>

   
</section>
<!-- <section class="team-area ptb-110"> 
<div
    class="page-heading"
    data-aos="fade-down"
        data-aos-easing="linear"
        data-aos-duration="1200"
    style="
        height: 150px;
        text-align: center;
        color: #000000;
        margin-bottom: 40px;
        text-transform: uppercase;
    "
>
    <h1>
        <b>Vocbot  Tackles Challenges: Simplifying Utility Management Solutions</b>
    </h1>
    <img src="assets/img/RO.gif" style="height: 35px" />
</div>

<div class="container-fluid"  >
    <div class="row">

        <div class="row member-content">
            <div class="col-lg-12 col-md-12">

               
                <div class="row row-margin-1" data-aos="zoom-in">
                    <div class="col-sm-12 col-md-4  col-lg-4 member-thumb-1 ">
                        <img   src="assets/img/utilities-bill.png" class="rounded-circle" alt="">
                       
                    </div>
                    <div class="col-sm-12 col-md-4 col-lg-8 mobile-content">
                        <div class="details-1" data-aos="fade-right"
                        data-aos-offset="500"
                        data-aos-easing="ease-in-sine">
                        
                            <p class="title mb-2">Bill Inquiries and Payments</p>
                            
                            <img src="assets/img/RO.gif" style="height: 35px" />
                            <p class="mt-2"> Vocbot  assist users in checking utility bills and payment
                                status. They facilitate secure online bill payments through
                                integrated systems.</p>
                        </div>
                    </div>
                </div>

              

    
                <div class="row row-margin-2 mobile-margin-top" data-aos="zoom-in">
                    
                    <div class="col-sm-12 col-lg-8 order-lg-1 order-sm-2 order-xs-2 order-2 mobile-content">
                        <div class="details-2" data-aos="fade-left"
                        data-aos-offset="500"
                        data-aos-easing="ease-in-sine " >
                            <p class="title mb-2">Usage Monitoring</p>
                            <img src="assets/img/RO.gif" style="height: 35px" />
                            <p class="mt-2"> Users can inquire about their utility consumption patterns.
                                Vocbot  provide insights into energy, water, or other utility
                                usage.</p>
                        </div>
                    </div>
                    <div class="col-sm-12 col-lg-4 member-thumb-2 order-lg-2  order-sm-1 order-xs-1 order-1 ">
                        <img  src="assets/img/utilities-monitoring.png" class="rounded-circle" alt="">
                       
                    </div>
                </div>


                
                <div class="row row-margin-1  mobile-margin-top" data-aos="zoom-in">
                    <div class="col-sm-12 col-lg-4 member-thumb-1  ">
                        <img src="assets/img/utilities-alert.png" class="rounded-circle" alt="">
                       
                    </div>
                    <div class="col-sm-12 col-lg-8  mobile-content">
                        <div class="details-1" data-aos="fade-right"
                        data-aos-offset="500"
                        data-aos-easing="ease-in-sine">
                            <p class="title mb-2">Service Outage Alerts</p>
                            <img src="assets/img/RO.gif" style="height: 35px" />
                            <p class="mt-2">Vocbot  notify users about scheduled maintenance or
                                unexpected service outages. They offer real-time updates on
                                resolution progress.</p>
                        </div>
                    </div>
                </div>

               

    
                <div class="row row-margin-2 mobile-margin-top" data-aos="zoom-in">
                    
                    <div class="col-sm-12 col-lg-8 order-lg-1 order-lg-2  order-sm-2 order-xs-2 order-2 mobile-content ">
                        <div class="details-2" data-aos="fade-left"
                        data-aos-offset="500"
                        data-aos-easing="ease-in-sine " >
                            <p class="title mb-2">Technical Support</p>
                            <img src="assets/img/RO.gif" style="height: 35px" />
                            <p class="mt-2">Users seek assistance for technical issues or disruptions.
                                Vocbot  provide troubleshooting tips and guide users through
                                problem resolution.</p>
                        </div>
                    </div>
                    <div class="col-sm-12 col-lg-4 member-thumb-2 order-lg-2 order-lg-1 order-sm-1 order-xs-1 order-1 ">
                        <img  src="assets/img/utilities-technical.png" class="rounded-circle" alt="">
                       
                    </div>
                </div>


               
                <div class="row row-margin-1 mobile-margin-top" data-aos="zoom-in">
                    <div class="col-sm-12 col-lg-4 member-thumb-1 order-lg-2 order-lg-1 order-sm-1 order-xs-1 order-1  ">
                        <img  src="assets/img/utilities-connection.png" class="rounded-circle" alt="">
                       
                    </div>
                    <div class="col-sm-12 col-lg-8 order-lg-1 order-lg-2  order-sm-2 order-xs-2 order-2 mobile-content">
                        <div class="details-1" data-aos="fade-right"
                        data-aos-offset="500"
                        data-aos-easing="ease-in-sine">
                            <p class="title mb-2">Connection/Disconnection Requests</p>
                            <img src="assets/img/RO.gif" style="height: 35px" />
                            <p class="mt-2"> Users can submit requests for new utility connections or
                                disconnections. Vocbot  streamline the application process
                                and provide status updates.</p>
                        </div>
                    </div>
                </div>

           

    
                <div class="row row-margin-2 mobile-margin-top " data-aos="zoom-in">
                    
                    <div class="col-sm-12 col-lg-8 order-lg-1 order-sm-2 order-xs-2 order-2 mobile-content">
                        <div class="details-2" data-aos="fade-left"
                        data-aos-offset="500"
                        data-aos-easing="ease-in-sine " >
                            <p class="title mb-2">Energy Efficiency Tips</p>
                            <img src="assets/img/RO.gif" style="height: 35px" />
                            <p class="mt-2">Vocbot  offer tips on optimizing energy usage for efficiency.
                                They suggest practices to reduce utility costs and
                                environmental impact.</p>
                        </div>
                    </div>
                    <div class="col-sm-12 col-lg-4 member-thumb-2 order-lg-2 order-lg-1 order-sm-1 order-xs-1 order-1 function-image  ">
                        <img  src="assets/img/utilities-energy.png" class="rounded-circle" alt="">
                       
                    </div>
                </div>

                <div class="row row-margin-1 mobile-margin-top" data-aos="zoom-in">
                    <div class="col-sm-12 col-lg-4 member-thumb-1 order-lg-1 order-sm-1 order-xs-1 order-1  function-image">
                        <img src="assets/img/utilities-feedback.png" class="rounded-circle" alt="">
                       
                    </div>
                    <div class="col-sm-12 col-lg-8 order-sm-2 order-xs-2 order-2 mobile-content">
                        <div class="details-1" data-aos="fade-right"
                        data-aos-offset="500"
                        data-aos-easing="ease-in-sine">
                            <p class="title mb-2">Feedback and Improvement Suggestions</p>
                            <img src="assets/img/RO.gif" style="height: 35px" />
                            <p class="mt-2"> Vocbot  collects user feedback on utility services. They may
                                gather suggestions for improvement, enhancing customer
                                satisfaction.</p>
                        </div>
                    </div>
                </div>


            </div>
        </div>
    
    </div>
</div>
</section> -->









<!-- Start Educational Area -->
<!-- <section class="features-area ptb-110"> -->
<!-- <div class="container-fluid">
    <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-12">
            <div
                class="image wow zoomIn"
                data-aos="fade-up"
                data-aos-anchor-placement="bottom-bottom"
            >
                <img
                    style="max-width: 40%"
                    src="assets/img/utilities-bill.png"
                    alt="image"
                />
            </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12">
            <div
                class="content"
                data-Aos="fade-left"
                data-aos-offset="200"
                data-aos-easing="ease-in-sine"
            >
                <h3><b>Bill Inquiries and Payments</b></h3>
                <img src="assets/img/RO.gif" style="height: 20px" />
                <p>
                    Vocbot  assist users in checking utility bills and payment
                    status. They facilitate secure online bill payments through
                    integrated systems.
                </p>
            </div>
        </div>
    </div>
</div>

<div
    class="container-fluid"
    style="background-image: url(assets/img/corner.jpg); background-size: cover"
>
    <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-12 order-lg-1 order-2">
            <div
                class="content"
                data-aos="fade-up"
                data-aos-anchor-placement="bottom-bottom"
            >
                <h3><b>Usage Monitoring</b></h3>
                <img src="assets/img/RO.gif" style="height: 20px" />
                <p>
                    Users can inquire about their utility consumption patterns.
                    Vocbot  provide insights into energy, water, or other utility
                    usage.
                </p>
            </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 order-lg-2 order-1">
            <div
                class="image wow zoomIn"
                data-aos="fade-up"
                data-aos-anchor-placement="bottom-bottom"
            >
                <img
                    style="max-width: 60%"
                    src="assets/img/utilities-monitoring.png"
                    alt="image"
                />
            </div>
        </div>
    </div>
</div>
<div class="container-fluid">
    <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-12">
            <div
                class="image wow zoomIn"
                data-aos="fade-up"
                data-aos-anchor-placement="bottom-bottom"
            >
                <img
                    style="max-width: 60%"
                    src="assets/img/utilities-alert.png"
                    alt="image"
                />
            </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12">
            <div
                class="content"
                data-Aos="fade-left"
                data-aos-offset="200"
                data-aos-easing="ease-in-sine"
            >
                <h3><b>Service Outage Alerts</b></h3>
                <img src="assets/img/RO.gif" style="height: 20px" />
                <p>
                    Vocbot  notify users about scheduled maintenance or
                    unexpected service outages. They offer real-time updates on
                    resolution progress.
                </p>
            </div>
        </div>
    </div>
</div>

<div
    class="container-fluid"
    style="background-image: url(assets/img/corner.jpg); background-size: cover"
>
    <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-12 order-lg-1 order-2">
            <div
                class="content"
                data-aos="fade-up"
                data-aos-anchor-placement="bottom-bottom"
            >
                <h3><b>Technical Support</b></h3>
                <img src="assets/img/RO.gif" style="height: 20px" />
                <p>
                    Users seek assistance for technical issues or disruptions.
                    Vocbot  provide troubleshooting tips and guide users through
                    problem resolution.
                </p>
            </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 order-lg-2 order-1">
            <div
                class="image wow zoomIn"
                data-aos="fade-up"
                data-aos-anchor-placement="bottom-bottom"
            >
                <img
                    style="max-width: 40%"
                    src="assets/img/utilities-technical.png"
                    alt="image"
                />
            </div>
        </div>
    </div>
</div>
<div class="container-fluid">
    <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-12">
            <div
                class="image wow zoomIn"
                data-aos="fade-up"
                data-aos-anchor-placement="bottom-bottom"
            >
                <img
                    style="max-width: 60%"
                    src="assets/img/utilities-connection.png"
                    alt="image"
                />
            </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12">
            <div
                class="content"
                data-Aos="fade-left"
                data-aos-offset="200"
                data-aos-easing="ease-in-sine"
            >
                <h3><b>Connection/Disconnection Requests</b></h3>
                <img src="assets/img/RO.gif" style="height: 20px" />
                <p>
                    Users can submit requests for new utility connections or
                    disconnections. Vocbot  streamline the application process
                    and provide status updates.
                </p>
            </div>
        </div>
    </div>
</div>

<div
    class="container-fluid"
    style="background-image: url(assets/img/corner.jpg); background-size: cover"
>
    <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-12 order-lg-1 order-2">
            <div
                class="content"
                data-aos="fade-up"
                data-aos-anchor-placement="bottom-bottom"
            >
                <h3><b>Energy Efficiency Tips</b></h3>
                <img src="assets/img/RO.gif" style="height: 20px" />
                <p>
                    Vocbot  offer tips on optimizing energy usage for efficiency.
                    They suggest practices to reduce utility costs and
                    environmental impact.
                </p>
            </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 order-lg-2 order-1">
            <div
                class="image wow zoomIn"
                data-aos="fade-up"
                data-aos-anchor-placement="bottom-bottom"
            >
                <img
                    style="max-width: 60%"
                    src="assets/img/utilities-energy.png"
                    alt="image"
                />
            </div>
        </div>
    </div>
</div>
<div class="container-fluid">
    <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-12">
            <div
                class="image wow zoomIn"
                data-aos="fade-up"
                data-aos-anchor-placement="bottom-bottom"
            >
                <img
                    style="max-width: 50%"
                    src="assets/img/utilities-feedback.png"
                    alt="image"
                />
            </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12">
            <div
                class="content"
                data-Aos="fade-left"
                data-aos-offset="200"
                data-aos-easing="ease-in-sine"
            >
                <h3><b>Feedback and Improvement Suggestions</b></h3>
                <img src="assets/img/RO.gif" style="height: 20px" />
                <p>
                    Vocbot  collects user feedback on utility services. They may
                    gather suggestions for improvement, enhancing customer
                    satisfaction.
                </p>
            </div>
        </div>
    </div>
</div>

<div class="rectangle-shape1" data-aos="zoom-in">
    <img src="assets/img/rectangle-shape1.png" alt="image" />
</div>
<div class="rectangle-shape2" data-aos="zoom-in">
    <img src="assets/img/rectangle-shape2.png" alt="image" />
</div> -->
